import React, { Component } from 'react';
import FileInput from 'react-fine-uploader/file-input';
import FineUploaderTraditional from 'fine-uploader-wrappers';
import { connect } from 'react-redux';
import FileListener from './FileListener';
import { Grid, Row, Col, Button, ButtonToolbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faImage } from '@fortawesome/free-regular-svg-icons';
import { withTranslation } from 'react-i18next';
import { API_ROOT } from '../../../middleware/api';

class FileUpload extends Component {

	constructor(props) {
		super(props);
		this.onFileRemove = this.onFileRemove.bind(this);
		this.uploader = this.createUploader();
	}

	createUploader() {
		return new FineUploaderTraditional({
			options: {
				debug: true,
				request: {
					endpoint: `${API_ROOT}/api/upload/document`,
					customHeaders: {
						'Accept': 'application/json',
						'X-Franchisor-Id': this.props.franchisorId,
						'Authorization': 'Bearer ' + this.props.accessToken
					}
				},
				chunking: {
					enabled: true,
					partSize: 5242880	// minimum 5MB per chunk required by Amazon S3
				},
				validation: {
					sizeLimit: 5000000
				}
			}
		});
	}

	onFileRemove() {
		const onChange = this.props.input.onChange;
		if (onChange) {
			onChange(null);
		}

		if (this.fileListener) {
			this.fileListener.clear();
		}
	}

	determineAcceptTypes() {
		if (this.props.image) {
			return 'image/*';
		} else {
			return '*';
		}
	}

	renderButtonToolbar(input, t, initialData, uploader, disabled) {
		const acceptTypes = this.determineAcceptTypes();
		const text = {
			selectFile: <span><FontAwesomeIcon icon={faImage} /> {t('FileUpload_Choose')}</span>
		};
		return (
			<ButtonToolbar>
				{disabled ||
					<FileInput className='btn btn-light-grey'
						accept={acceptTypes}
						uploader={uploader}
						text={text} />
				}
				{input.value &&
					<Button bsStyle='danger' disabled={disabled} onClick={this.onFileRemove}><FontAwesomeIcon icon={faXmark} /> {t('FileUpload_Remove')}</Button>
				}
			</ButtonToolbar>
		)
	}

	render() {
		const { input, initialData, image, t, disabled } = this.props;
		const buttonToolbar = this.renderButtonToolbar(input, t, initialData, this.uploader, disabled);
		return (
			<Row>
				<Col sm={12}>
					<FileListener uploader={this.uploader}
						input={input}
						initialData={initialData}
						image={image}
						ref={instance => this.fileListener = instance} />
					<Row style={{ marginTop: '10px' }}>
						<Col sm={12}>
							{buttonToolbar}
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

}

const mapStateToProps = state => {
	const {
		configuration,
		auth } = state;

	return {
		franchisorId: configuration.franchisor.id,
		accessToken: auth.accessToken
	};
};

export default withTranslation()(connect(mapStateToProps)(FileUpload));